import React from "react"

export const Input = React.forwardRef(
  (
    {
      type = "text",
      value,
      onChange,
      placeholder,
      disabled = false,
      className = "",
      maxLength,
      inputMode,
      ...props
    },
    ref
  ) => {
    return (
      <input
        ref={ref}
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
        className={className}
        maxLength={maxLength}
        inputMode={inputMode}
        {...props}
      />
    )
  }
)

Input.displayName = "Input"
